document.addEventListener('DOMContentLoaded', async () => {
  try {
    // Shopifyから現在のカート情報を取得
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // ネコポス条件：
    // 「ウェルカムセット」1商品のみ、かつ数量1
    const isNekoposuOrder =
      cart.items.length === 1 &&
      cart.items[0].handle === 'welcomset' &&
      cart.items[0].quantity === 1;

    console.log(
      '[aroma-pathi shipping]',
      isNekoposuOrder ? 'ネコポス対象' : '宅配便対象'
    );

    // カートが空なら終了
    if (cart.items.length === 0) return;

    // 各商品を確認
    for (const item of cart.items) {
      const currentProperties = item.properties || {};
      const hasNekoposu =
        currentProperties._配送方法 === 'ネコポス';

      // ① ウェルカムセット×1だけ → ネコポスを設定
      if (isNekoposuOrder && !hasNekoposu) {
        const properties = {
          ...currentProperties,
          _配送方法: 'ネコポス'
        };

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: properties
          })
        });

        console.log(
          '[aroma-pathi shipping] _配送方法：ネコポス を設定しました'
        );
      }

      // ② それ以外 → ネコポス情報が残っていたら削除
      if (!isNekoposuOrder && hasNekoposu) {
        const properties = { ...currentProperties };

        delete properties._配送方法;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: properties
          })
        });

        console.log(
          '[aroma-pathi shipping] _配送方法を削除しました'
        );
      }
    }
  } catch (error) {
    console.error(
      '[aroma-pathi shipping] 配送方法の設定に失敗しました',
      error
    );
  }
});